// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-section {
  background-color: #fdf9ee;
}

.hero-section__row {
  min-height: 320px;
}

.hero-section__copy {
  padding-top: 3rem;
  padding-bottom: 3rem;
}

html body .hero-section__headline {
  font-size: clamp(2rem, 4vw, 3.5rem) !important;
  font-weight: 700 !important;
  line-height: 1.2 !important;
  margin: 0 0 1rem !important;
  text-align: left;
  white-space: normal !important;
}

.hero-section__body {
  margin: 0;
  white-space: pre-wrap;
}

.hero-section__cta {
  margin-top: 1.5rem;
}

.hero-section__cta-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.hero-section__media {
  position: relative;
  overflow: hidden;
  min-height: 280px;
  height: 100%;
}

.hero-section__media img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-top-left-radius: 60px;
}

.hero-section--preview {
  border: 1px solid #ece6d8;
  border-radius: 16px;
  overflow: hidden;
  pointer-events: none;
  user-select: none;
}

.hero-section--preview .hero-section__copy {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

html body .hero-section--preview .hero-section__headline {
  font-size: clamp(1.35rem, 2.6vw, 2.2rem) !important;
}

.hero-section--preview .hero-section__body {
  font-size: 14px;
  line-height: 1.45;
}

.hero-section--preview .hero-section__media {
  min-height: 220px;
}

.hero-section--preview .hero-section__media img {
  border-top-left-radius: 32px;
}

.hero-section--preview .hero-section__cta-btn {
  padding: 6px 20px !important;
  font-size: 13px !important;
}

.hero-section--image-only {
  background-color: #fdf9ee;
}

.hero-section__media--solo {
  position: relative;
  min-height: 0;
  height: auto;
  overflow: hidden;
}

.hero-section__media--solo img {
  position: static;
  inset: auto;
  display: block;
  width: 100%;
  height: auto;
  max-height: 420px;
  object-fit: cover;
  object-position: center;
  border-radius: 24px;
  border-top-left-radius: 24px;
}

.hero-section--preview .hero-section__media--solo img {
  max-height: 220px;
  border-radius: 16px;
  border-top-left-radius: 16px;
}

@media (max-width: 991.98px) {
  .hero-section__copy {
    padding-top: 2rem;
    padding-bottom: 1.25rem;
  }

  .hero-section__media {
    min-height: 220px;
    aspect-ratio: 16 / 10;
  }

  .hero-section__media img {
    border-top-left-radius: 28px;
    border-top-right-radius: 28px;
  }

  .hero-section__media--solo img {
    max-height: 280px;
    border-radius: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/web-pages/HeroSection.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF","sourcesContent":[".hero-section {\n  background-color: #fdf9ee;\n}\n\n.hero-section__row {\n  min-height: 320px;\n}\n\n.hero-section__copy {\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n}\n\nhtml body .hero-section__headline {\n  font-size: clamp(2rem, 4vw, 3.5rem) !important;\n  font-weight: 700 !important;\n  line-height: 1.2 !important;\n  margin: 0 0 1rem !important;\n  text-align: left;\n  white-space: normal !important;\n}\n\n.hero-section__body {\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n.hero-section__cta {\n  margin-top: 1.5rem;\n}\n\n.hero-section__cta-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n}\n\n.hero-section__media {\n  position: relative;\n  overflow: hidden;\n  min-height: 280px;\n  height: 100%;\n}\n\n.hero-section__media img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  border-top-left-radius: 60px;\n}\n\n.hero-section--preview {\n  border: 1px solid #ece6d8;\n  border-radius: 16px;\n  overflow: hidden;\n  pointer-events: none;\n  user-select: none;\n}\n\n.hero-section--preview .hero-section__copy {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n\nhtml body .hero-section--preview .hero-section__headline {\n  font-size: clamp(1.35rem, 2.6vw, 2.2rem) !important;\n}\n\n.hero-section--preview .hero-section__body {\n  font-size: 14px;\n  line-height: 1.45;\n}\n\n.hero-section--preview .hero-section__media {\n  min-height: 220px;\n}\n\n.hero-section--preview .hero-section__media img {\n  border-top-left-radius: 32px;\n}\n\n.hero-section--preview .hero-section__cta-btn {\n  padding: 6px 20px !important;\n  font-size: 13px !important;\n}\n\n.hero-section--image-only {\n  background-color: #fdf9ee;\n}\n\n.hero-section__media--solo {\n  position: relative;\n  min-height: 0;\n  height: auto;\n  overflow: hidden;\n}\n\n.hero-section__media--solo img {\n  position: static;\n  inset: auto;\n  display: block;\n  width: 100%;\n  height: auto;\n  max-height: 420px;\n  object-fit: cover;\n  object-position: center;\n  border-radius: 24px;\n  border-top-left-radius: 24px;\n}\n\n.hero-section--preview .hero-section__media--solo img {\n  max-height: 220px;\n  border-radius: 16px;\n  border-top-left-radius: 16px;\n}\n\n@media (max-width: 991.98px) {\n  .hero-section__copy {\n    padding-top: 2rem;\n    padding-bottom: 1.25rem;\n  }\n\n  .hero-section__media {\n    min-height: 220px;\n    aspect-ratio: 16 / 10;\n  }\n\n  .hero-section__media img {\n    border-top-left-radius: 28px;\n    border-top-right-radius: 28px;\n  }\n\n  .hero-section__media--solo img {\n    max-height: 280px;\n    border-radius: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
